import { DashboardState } from "features/Dashboard/runtime/dashboardStore"
import { liveFilterSelections } from "features/Dashboard/runtime/universeComposer"

const last = (p: string): string => p.split("//").pop() ?? p

/**
 * One line naming what the viewer has filtered on: each dashboard filter
 * with a selection, then each cross-filter. Empty when nothing is active.
 * Selections the tiles ignore (not in the codebook) are left out.
 */
export const filterSummary = (
  state: Pick<
    DashboardState,
    "document" | "filterSelections" | "crossFilters"
  > & { codebook?: DashboardState["codebook"] }
): string => {
  const parts: string[] = []
  const selections = liveFilterSelections(
    state.document.filters,
    state.filterSelections,
    state.codebook ?? null
  )
  state.document.filters.forEach((f) => {
    const sel = selections[f.id] ?? []
    if (sel.length > 0) parts.push(`${f.label} = ${sel.join(" or ")}`)
  })
  Object.values(state.crossFilters).forEach((cf) => {
    if (cf.categories.length > 0) {
      parts.push(`${last(cf.variable)} = ${cf.categories.join(" or ")}`)
    }
  })
  return parts.length > 0 ? `Filtered: ${parts.join("; ")}` : ""
}
